import React from 'react'
import asethic from '../image/aesthic.png'
import lms from '../image/lms.png'
import webapp from '../image/web app.jpg'
import '../Component/project.css'
import git from '../image/git.png'

export default function Project() {
  return (
    <div>
    <div className='title-1' id='projects'>
    <h1 data-aos="fade-down">Projects<span id="line-3"></span></h1>
    </div>
      <div className='project'>
        <div className='procard' data-aos="fade-right">
          <img src={asethic}/>
          <a href='https://github.com/WaleedAhmed06'><img src={git} alt="github" /></a>
          <p id='proheading'>Responsive Web</p>
          <p>Explore our dynamic website, optimized for flawless user experience on any device. The responsive layout ensures seamless browsing. Enjoy a consistent interface, whether on a smartphone, tablet, or desktop.</p>
          <p><span id='protag1'>#HTML</span> <span id='protag2'>#CSS</span></p>
          </div>
        <div className='procard' data-aos="fade-up">
          <img src={lms}/>
          <a href='https://github.com/WaleedAhmed06'><img src={git} alt="github" /></a>
          <p id='proheading'>Web App And LMS</p>
          <p>Our innovative web app simplifies tasks, providing seamless user experience with powerful features. Building an intuitive LMS platform to streamline learning and enhance educational experiences for all users.</p>
          <p><span id='protag3'>#MERN</span> <span id='protag1'>#NEXT.JS</span></p>
          </div>
        <div className='procard' data-aos="fade-left">
          <img src={webapp}/>
          <a href='https://github.com/WaleedAhmed06'><img src={git} alt="github" /></a>
          <p id='proheading'>Mobile App</p>
          <p>Dynamic mobile applications with React Native, harnessing its powerful cross-platform capabilities. Crafting intuitive user experiences and leveraging the latest trends in mobile development to deliver seamless.</p>
          <p><span id='protag3'>#REACTNATIVE</span></p>
        </div>
      </div>
    </div>
  )
}
